export class WalletUnlockRequiredError extends Error {
  constructor() {
    super('Unlock your wallet with a passkey to continue.');
    this.name = 'WalletUnlockRequiredError';
  }
}

export class WalletOperation {
  constructor(readonly isCurrent: () => boolean) {}

  assertCurrent(): void {
    if (!this.isCurrent()) {
      throw new WalletUnlockRequiredError();
    }
  }

  narrow(isAlsoCurrent: () => boolean): WalletOperation {
    return new WalletOperation(() => this.isCurrent() && isAlsoCurrent());
  }

  async run<T>(work: () => Promise<T>): Promise<T> {
    this.assertCurrent();
    const result = await work();
    this.assertCurrent();
    return result;
  }
}
